import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/shared/PageHeader';
import { TransactionDetails } from '@/components/features/transactions/TransactionDetails';
import { Breadcrumbs } from '@/components/shared/Breadcrumbs';
import { LoadingState } from '@/components/shared/LoadingState';
import { ErrorState } from '@/components/shared/ErrorState';
import { useTransaction } from '@/lib/hooks';
import { ROUTES } from '@/config/routes';

export const Route = createFileRoute('/_auth/_admin/admin/transactions/$id')({
  component: TransactionDetailComponent,
});

function TransactionDetailComponent() {
  const { id } = Route.useParams();
  const { data, isLoading, isError, error } = useTransaction(Number(id));

  const breadcrumbs = [
    { label: 'Transactions', href: ROUTES.ADMIN.TRANSACTIONS },
    { label: `#${id}` },
  ];

  if (isLoading) {
    return <LoadingState />;
  }

  if (isError) {
    return <ErrorState title={error.name} message={error.message} />;
  }

  return (
    <div className="space-y-6">
      <Breadcrumbs items={breadcrumbs} />
      
      <PageHeader
        title="Transaction Details"
        description={`Transaction #${id}`}
      />

      <TransactionDetails transaction={data!} />

      {/*<TransactionTimeline transaction={data.} />*/}
    </div>
  );
}
